// extracted by mini-css-extract-plugin
export default {"container":"container-Dt0uC","item":"item-oWSRc","title":"title-a1952","description":"description-X97Hs"};